import { Checkbox, FormControlLabel, Paper, Typography } from '@material-ui/core';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { API_elaboraSchedaBudget } from '../../utils/functions';
import { SchedaBudgetInputProps } from './InformazioniCosti';

export default function IscrizioneRegistroImprese(props: SchedaBudgetInputProps) {
    const gClasses = globalStyles();
    const action = "changeIscrizioneRegistroImprese";
    const { state } = props;
    const [global] = useGlobal<IGlobalState>();

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    };

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;
        props.handleChange(action, name, checked);
        API_elaboraSchedaBudget(props, global, e.target.name, e.target.checked, action, true);
    }

    const handleBlur = (e: any) => {
        API_elaboraSchedaBudget(props, global);
    }

    return (
        <Paper className={gClasses.mainPaper}>
            <SectionSubTitle text="Società ed enti collettivi"></SectionSubTitle>
            <Typography variant="h6">Prima iscrizione</Typography>
            <NumberField
                name="J10_su_supporto_informatico_digitale"
                label="Su supporto informatico digitale"
                value={state.iscrizioneRegistroImprese.J10_su_supporto_informatico_digitale}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
            />
            <Checkbox
                checked={state.iscrizioneRegistroImprese.I10_su_supporto_informatico_digitale}
                name='I10_su_supporto_informatico_digitale'
                value={state.iscrizioneRegistroImprese.I10_su_supporto_informatico_digitale}
                inputProps={{ 'aria-label': 'primary checkbox' }}
                onChange={handleChangeChecked}
            />
            <NumberField
                name="J11_con_modalita_telematica"
                label="Con modalità telematica"
                value={state.iscrizioneRegistroImprese.J11_con_modalita_telematica}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
            />
            <Checkbox
                checked={state.iscrizioneRegistroImprese.I11_con_modalita_telematica}
                name='I11_con_modalita_telematica'
                value={state.iscrizioneRegistroImprese.I11_con_modalita_telematica}
                inputProps={{ 'aria-label': 'primary checkbox' }}
                onChange={handleChangeChecked}
            />
            <FormControlLabel className={gClasses.bottomControlLabel}
                labelPlacement="end"
                control={
                    <Checkbox
                        checked={state.iscrizioneRegistroImprese.I13_riduzione_del_50_per_le_cooperative_sociali}
                        name='I13_riduzione_del_50_per_le_cooperative_sociali'
                        value={state.iscrizioneRegistroImprese.I13_riduzione_del_50_per_le_cooperative_sociali}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                        onChange={handleChangeChecked}
                    />
                }
                label="Riduzione del 50% per le cooperative sociali"
            />
            <NumberField
                name="J15_maggiorazione"
                label="Maggiorazione"
                value={state.iscrizioneRegistroImprese.J15_maggiorazione}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
                tooltip="La maggiorazione si applica alle imprese di cui alle Leggi: 46/1990 (Installazione impianti), 122/1992 (Autoriparazioni),  82/1994 (Pulizie) e 57/2001 (Facchinaggio)"
            />
            <Checkbox
                checked={state.iscrizioneRegistroImprese.I15_maggiorazione}
                name='I15_maggiorazione'
                value={state.iscrizioneRegistroImprese.I15_maggiorazione}
                inputProps={{ 'aria-label': 'primary checkbox' }}
                onChange={handleChangeChecked}
            />
            <NumberField
                name="J17_imposta_di_bollo_societa_di_persone"
                label="Imposta di bollo società di persone"
                value={state.iscrizioneRegistroImprese.J17_imposta_di_bollo_societa_di_persone}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
            />
            <Checkbox
                checked={state.iscrizioneRegistroImprese.I17_imposta_di_bollo_societa_di_persone}
                name='I17_imposta_di_bollo_societa_di_persone'
                value={state.iscrizioneRegistroImprese.I17_imposta_di_bollo_societa_di_persone}
                inputProps={{ 'aria-label': 'primary checkbox' }}
                onChange={handleChangeChecked}
            />
            <NumberField
                name="J18_imposta_di_bollo_societa_di_capitali"
                label="Imposta di bollo società di capitali"
                value={state.iscrizioneRegistroImprese.J18_imposta_di_bollo_societa_di_capitali}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
            />
            <Checkbox
                checked={state.iscrizioneRegistroImprese.I18_imposta_di_bollo_societa_di_capitali}
                name='I18_imposta_di_bollo_societa_di_capitali'
                value={state.iscrizioneRegistroImprese.I18_imposta_di_bollo_societa_di_capitali}
                inputProps={{ 'aria-label': 'primary checkbox' }}
                onChange={handleChangeChecked}
            />
            <NumberField
                name="J20_altro"
                label="Altro"
                value={state.iscrizioneRegistroImprese.J20_altro}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
            />
            <SectionSubTitle text="Imprese individuali"></SectionSubTitle>
            <Typography variant="h6">Prima iscrizione</Typography>
            <NumberField
                name="J24_su_supporto_informatico_digitale_o_per_via_telematica"
                label="Su supporto informatico digitale o per via telematica"
                value={state.iscrizioneRegistroImprese.J24_su_supporto_informatico_digitale_o_per_via_telematica}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
            />
            <Checkbox
                checked={state.iscrizioneRegistroImprese.I24_su_supporto_informatico_digitale_o_per_via_telematica}
                name='I24_su_supporto_informatico_digitale_o_per_via_telematica'
                value={state.iscrizioneRegistroImprese.I24_su_supporto_informatico_digitale_o_per_via_telematica}
                inputProps={{ 'aria-label': 'primary checkbox' }}
                onChange={handleChangeChecked}
            />
            <NumberField
                name="J26_maggiorazione"
                label="Maggiorazione"
                value={state.iscrizioneRegistroImprese.J26_maggiorazione}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
                tooltip="La maggiorazione si applica alle imprese di cui alle Leggi: 46/1990 (Installazione impianti), 122/1992 (Autoriparazioni),  82/1994 (Pulizie) e 57/2001 (Facchinaggio)"
            />
            <Checkbox
                checked={state.iscrizioneRegistroImprese.I26_maggiorazione}
                name='I26_maggiorazione'
                value={state.iscrizioneRegistroImprese.I26_maggiorazione}
                inputProps={{ 'aria-label': 'primary checkbox' }}
                onChange={handleChangeChecked}
            />
            <NumberField
                name="J28_imposta_di_bollo"
                label="Imposta di bollo"
                value={state.iscrizioneRegistroImprese.J28_imposta_di_bollo}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
            />
            <Checkbox
                checked={state.iscrizioneRegistroImprese.I28_imposta_di_bollo}
                name='I28_imposta_di_bollo'
                value={state.iscrizioneRegistroImprese.I28_imposta_di_bollo}
                inputProps={{ 'aria-label': 'primary checkbox' }}
                onChange={handleChangeChecked}
            />
            <NumberField
                name="J30_altro"
                label="Altro"
                value={state.iscrizioneRegistroImprese.J30_altro}
                className={gClasses.textField}
                onChange={handleChange} onBlur={handleBlur}
            />
        </Paper>
    )
}